module.exports = __webpack_public_path__ + "images/marketing/peeps/frank_hmeidan.jpg";